import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

function MonthlyUserList() {
    const [users, setUsers] = useState([]); // Store API data
    const [currentPage, setCurrentPage] = useState(1); // State to track current page
    const [searchQuery, setSearchQuery] = useState(""); // Search query state
    const usersPerPage = 9;
    const navigate = useNavigate();

    // Fetch data from API using Axios
    useEffect(() => {
        axios
            .get(`${process.env.REACT_APP_BASE_API_URL}/getUser/api/monthlyUserList`) // Replace with actual API
            .then((response) => setUsers(response.data))
            .catch((error) => console.error("Error fetching users:", error));
    }, []);

    // Filter users based on search query (case-insensitive)
    const filteredUsers = users.filter((user) =>
        user.vehicleNumber.toUpperCase().includes(searchQuery.toUpperCase())
    );

    // Pagination logic
    const totalPages = Math.ceil(filteredUsers.length / usersPerPage);
    const indexOfLastUser = currentPage * usersPerPage;
    const indexOfFirstUser = indexOfLastUser - usersPerPage;
    const currentUsers = filteredUsers.slice(indexOfFirstUser, indexOfLastUser);

    // Function to change pages
    const handlePageChange = (pageNumber) => {
        if (pageNumber >= 1 && pageNumber <= totalPages) {
            setCurrentPage(pageNumber);
        }
    };

    // Function to navigate to User Details page
    const goToUserDetails = (id) => {
        navigate(`/adminDashboard/monthlyParkingUserDetail/${id}`);
    };

    return (
        <div className="monthlyUserList container mt-5">
            <button className="btn btn-secondary mt-3" onClick={() => navigate(-1)}>
                ⬅ Back
            </button>
            <h1 className="text-center mb-4">Monthly User List</h1>

            {/* Search Bar */}
            <div className="d-flex flex-column align-items-center">
                <label className="mb-2 fw-bold col-sm-10">Search Vehicle Here</label>
                <div className="input-group mb-3" style={{ width: "400px" }}>
                    <input
                        className="form-control form-control-lg"
                        type="search"
                        placeholder="Search by Vehicle Number"
                        aria-label="Search"
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                    />
                    <button className="btn btn-primary px-4" type="button">
                        <i className="bi bi-search"></i>
                    </button>
                </div>
            </div>

            {/* User Cards Grid */}
            <div className="row">
                {currentUsers.length > 0 ? (
                    currentUsers.map((user) => (
                        <div key={user._id} className="col-lg-4 col-md-6 col-sm-12 mb-4">
                            <div className="card p-3 shadow-sm text-center">

                                {/* Image Wrapper with Badge */}
                                <div className="position-relative d-inline-block">
                                    {/* Vehicle Image */}
                                    <img
                                        src={`${process.env.REACT_APP_BASE_API_URL}/monthlyUploads/${user?.vehicleImage.split("\\").pop()}`}
                                        alt="user vehicle"
                                        className="rounded-circle img-fluid custom-img"
                                        style={{ width: "120px", height: "120px", objectFit: "cover" }}
                                    />

                                    {/* 🚨 Closure Request Badge in top-right inside card */}
                                    {user.closed ? (
                                        <span
                                            className="badge bg-dark position-absolute top-0 end-0"
                                            title={`Closed on ${user.closedDate
                                                    ? new Date(user.closedDate).toLocaleDateString()
                                                    : "N/A"
                                                }`}
                                            style={{ fontSize: "0.8rem" }}
                                        >
                                            ✅ Closed
                                        </span>
                                    ) : user.closureRequest ? (
                                        <span
                                            className="badge bg-danger position-absolute top-0 end-0"
                                            title={`Closure Requested on ${user.closureRequestDate || "N/A"}`}
                                            style={{ fontSize: "0.8rem" }}
                                        >
                                            🚫 Closing Requested
                                        </span>
                                    ) : null}

                                </div>

                                {/* User Details */}
                                <h2 className="h5 mt-3">Customer Name: {user.customerName}</h2>
                                <p className="fw-bold">
                                    Vehicle No: {user.vehicleNumber.toUpperCase()}
                                </p>
                                <p>{user.email}</p>

                                {/* View Button */}
                                <div className="viewButton">
                                    <button
                                        className="btn btn-primary"
                                        onClick={() => goToUserDetails(user._id)}
                                    >
                                        View More
                                    </button>
                                </div>
                            </div>
                        </div>
                    ))
                ) : (
                    <div className="text-center mt-4">
                        <h5>No results found</h5>
                    </div>
                )}
            </div>

            {/* Pagination Controls */}
            {filteredUsers.length > usersPerPage && (
                <nav>
                    <ul className="pagination justify-content-center">
                        {/* Previous Button */}
                        <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                            <button
                                className="page-link"
                                onClick={() => handlePageChange(currentPage - 1)}
                            >
                                Previous
                            </button>
                        </li>

                        {/* Page Numbers */}
                        {Array.from({ length: totalPages }, (_, index) => (
                            <li
                                key={index}
                                className={`page-item ${currentPage === index + 1 ? "active" : ""}`}
                            >
                                <button
                                    className="page-link"
                                    onClick={() => handlePageChange(index + 1)}
                                >
                                    {index + 1}
                                </button>
                            </li>
                        ))}

                        {/* Next Button */}
                        <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                            <button
                                className="page-link"
                                onClick={() => handlePageChange(currentPage + 1)}
                            >
                                Next
                            </button>
                        </li>
                    </ul>
                </nav>
            )}
        </div>
    );
}

export default MonthlyUserList;
